<template>
  <v-container fluid class="pa-0">
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-1">{{ $t('Sistemos parametrai') }}</h1>

    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-text>
        <!-- Sesija -->
        <div class="param-section-header">
          <h3 class="param-section-title">{{ $t('Sesija') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row :label="$t('Atjungimo nuo sistemos laikas (min)')">
                    <el-text-field
                      hide-details
                      v-model="formData.logout_time"
                      required
                      integer
                      validateKey="logout_time"
                      key="logout_time"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- Registracija ir naudotojai -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('Registracija, apmokėjimas ir naudotojai') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row :label="$t('Apmokėjimo laikas (dienomis)')">
                    <el-text-field
                      hide-details
                      v-model="formData.payment_time"
                      required
                      integer
                      validateKey="payment_time"
                      key="payment_time"
                    />
                  </param-row>
                  <param-row :label="$t('Įgaliotojų patvirtinimo laikas (dienomis)')">
                    <el-text-field
                      hide-details
                      v-model="formData.confirm_time"
                      required
                      integer
                      validateKey="confirm_time"
                      key="confirm_time"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    :label="
                      $t(
                        'Naudotojų minimalus amžius išrašams savitarnoje gauti'
                      )
                    "
                  >
                    <el-text-field
                      hide-details
                      v-model="formData.min_age"
                      required
                      integer
                      validateKey="min_age"
                      key="min_age"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- Automatinės užduotys -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('Automatinės užduotys ir duomenų saugojimas') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row :label="$t('Automatinio išregistravimo laikas')">
                    <el-time-picker
                      v-model="formData.deregistration_time"
                      required
                      validateKey="deregistration_time"
                      key="deregistration_time"
                      format="24hr"
                    />
                  </param-row>
                  <param-row :label="$t('ILTU kodo gavimo iš RC ASMENYS')">
                    <el-time-picker
                      v-model="formData.check_iltu"
                      required
                      validateKey="check_iltu"
                      key="check_iltu"
                      format="24hr"
                    />
                  </param-row>
                  <param-row
                    :label="
                      $t(
                        'Užklausų žurnalo įrašų saugojimas dienomis. (Suėjus šiam terminui įrašai bus ištrinami negrįžtamai)'
                      )
                    "
                  >
                    <el-text-field
                      hide-details
                      v-model="formData.log_save_time"
                      required
                      integer
                      validateKey="log_save_time"
                      key="log_save_time"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    :label="
                      $t('Objekto duomenų naikinimo akto sunaikinimo laikas')
                    "
                  >
                    <el-time-picker
                      v-model="formData.delete_mandates"
                      required
                      validateKey="delete_mandates"
                      key="delete_mandates"
                      format="24hr"
                    />
                  </param-row>
                  <param-row
                    :label="
                      $t(
                        'Išrašų paieškų naikinimo ataskaitos sunaikinimo laikas'
                      )
                    "
                  >
                    <el-time-picker
                      v-model="formData.delete_statements"
                      required
                      validateKey="delete_statements"
                      key="delete_statements"
                      format="24hr"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- SMS siuntimo atidėjimas -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('SMS siuntimo atidėjimas') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    checkbox
                    :label="$t('SMS siuntimo atidėjimas įjungtas')"
                  >
                    <el-checkbox
                      label=""
                      v-model="formData.sms_delayed_send_enabled"
                      @change="onSmsDelayedSendEnabledChange"
                    />
                  </param-row>
                  <param-row
                    :label="$t('SMS siuntimo atidėjimo intervalas nuo')"
                  >
                    <el-time-picker
                      v-model="formData.sms_delayed_send_interval[0]"
                      :required="smsDelayedSendEnabled"
                      :disabled="!smsDelayedSendEnabled"
                      validateKey="sms_delayed_send_interval.0"
                      key="sms_delayed_send_interval_0"
                      format="24hr"
                    />
                  </param-row>
                  <param-row
                    :label="$t('SMS siuntimo atidėjimo intervalas iki')"
                  >
                    <el-time-picker
                      v-model="formData.sms_delayed_send_interval[1]"
                      :required="smsDelayedSendEnabled"
                      :disabled="!smsDelayedSendEnabled"
                      validateKey="sms_delayed_send_interval.1"
                      key="sms_delayed_send_interval_1"
                      format="24hr"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- Išregistravimo ir galiojimo priminimai -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">
            {{ $t('El. pašto ir SMS priminimai apie išregistravimą') }}
          </h3>
          <v-divider />
        </div>
        <div class="param-expiry-reminders">
          <v-row class="param-expiry-reminders__time-row">
            <v-col class="pb-0" cols="12" md="6">
              <v-simple-table dense class="param-fields-table">
                <template v-slot:default>
                  <colgroup>
                    <col class="param-fields-table__label-col" />
                    <col class="param-fields-table__value-col" />
                  </colgroup>
                  <tbody>
                    <param-row :label="$t('Priminimų siuntimo laikas')">
                      <el-time-picker
                        v-model="formData.expiry_reminder_time"
                        required
                        validateKey="expiry_reminder_time"
                        key="expiry_reminder_time"
                        format="24hr"
                      />
                    </param-row>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row class="param-expiry-reminders__fields-row">
            <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    v-for="reminderType in expiryReminderTypeConfigs"
                    :key="`expiry_days_${reminderType.type}`"
                    :label="expiryReminderDaysRowLabel(reminderType)"
                  >
                    <el-text-field
                      hide-details
                      v-model="formData.expiry_reminder_days[reminderType.type]"
                      comma-separated-digits
                      :validateKey="`expiry_reminder_days.${reminderType.type}`"
                      :key="`expiry_reminder_days_${reminderType.type}`"
                      :placeholder="$t('pvz. 30,7')"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    v-for="reminderType in expiryReminderTypeConfigs"
                    :key="`expiry_roles_${reminderType.type}`"
                    :label="expiryReminderRolesRowLabel(reminderType)"
                  >
                    <el-select
                      multiple
                      direct
                      hide-details
                      :items="expiryReminderRoleItems(reminderType)"
                      itemtext="text"
                      itemvalue="value"
                      v-model="formData.expiry_reminder_roles[reminderType.type]"
                      :validateKey="`expiry_reminder_roles.${reminderType.type}`"
                      :key="`expiry_reminder_roles_${reminderType.type}`"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          </v-row>
        </div>

        <!-- Asmens duomenys ir elgsena -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('Asmens duomenys ir sistemos elgsena') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    checkbox
                    unused
                    :label="
                      $t(
                        'Tikrinti naudotojų neveiksnumą iškarto jiems prisijungus'
                      )
                    "
                  >
                    <el-checkbox
                      label=""
                      v-model="formData.incapacity"
                    />
                  </param-row>
                  <param-row
                    checkbox
                    :label="
                      $t(
                        'Asmens dokumentai ir jų duomenys yra privalomi įvedant asmenį su gimimo data'
                      )
                    "
                  >
                    <el-checkbox
                      label=""
                      v-model="formData.is_person_documents_mandatory"
                    />
                  </param-row>
                  <param-row
                    checkbox
                    unused
                    :label="
                      $t(
                        'Tikrinti asmens neveiksnumą pridedant asmenį į (Prokūrą/Įgaliojimą)'
                      )
                    "
                  >
                    <el-checkbox
                      label=""
                      v-model="formData.incapacity_object"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    checkbox
                    :label="
                      $t('Prokūrai automatiškai nustatyti pasirašančius asmenis')
                    "
                  >
                    <el-checkbox
                      label=""
                      v-model="formData.auto_signatures_procuracy"
                    />
                  </param-row>
                  <param-row
                    :label="
                      $t(
                        'Asmens įterpimo į ASMENYS posistemę funkcijos naudojimas'
                      )
                    "
                  >
                    <el-autocomplete
                      hide-details
                      :items="enumsClassifiers.insertFunctions"
                      enums
                      v-model="formData.asmenys_insert_function"
                      required
                      validateKey="asmenys_insert_function"
                      key="asmenys_insert_function"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- Prisegami failai -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('Prisegami failai') }}</h3>
          <v-divider />
        </div>
        <v-row>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row :label="`${$t('Prisegamo failo dydis')} (MB)`">
                    <el-text-field
                      hide-details
                      v-model="formData.file_size"
                      required
                      integer
                      validateKey="file_size"
                      key="file_size"
                      :max="20"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="6">
            <v-simple-table dense class="param-fields-table">
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row align-top :label="$t('Prisegamo failo tipas')">
                    <el-textarea
                      hide-details
                      v-model="formData.file_type"
                      required
                      validateKey="file_type"
                      key="file_type"
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- Naudotojų vadovai -->
        <div class="param-section-header param-section-header--spaced">
          <h3 class="param-section-title">{{ $t('Naudotojų vadovai') }}</h3>
          <v-divider />
        </div>
        <v-row class="pt-0">
          <v-col class="pb-0" cols="12">
            <v-simple-table
              dense
              class="param-fields-table param-fields-table--manuals"
            >
              <template v-slot:default>
                <colgroup>
                  <col class="param-fields-table__label-col" />
                  <col class="param-fields-table__value-col" />
                </colgroup>
                <tbody>
                  <param-row
                    v-for="manual in manualFields"
                    :key="manual.key"
                    file
                    :label="$t(manual.label)"
                  >
                    <el-file-input
                      label=" "
                      v-model="files[manual.key]"
                      :fileData="formData[manual.key]"
                      :disabled="modeReadonly"
                      @addFile="addFile($event, manual.key)"
                      @clearFile="clearFile($event, manual.key)"
                      :validateKey="manual.key"
                      emitClearFile
                    />
                  </param-row>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row class="pl-2 py-2" no-gutters>
      <v-spacer></v-spacer>
      <el-button
        v-if="!modeReadonly"
        title="Išsaugoti"
        :loading="loading"
        @click.native="saveData()"
        color="primary"
        icon="išsaugoti"
      />
    </v-row>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'
import Enums from '@/enums'
import ParamRow from './ParamRow.vue'

export default {
  name: 'AdminParameters',
  components: { ParamRow },
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loadDefault: null,
      pageloading: true,
      loading: true,
      formData: {},
      files: {},
      uploadedFiles: {},
      deletedFiles: {},
      enumsClassifiers: [],
      expiryReminderTypeConfigs: [
        {
          type: 'itpsi',
          label: 'ITPSĮ',
          roles: [
            { key: 'principal', label: 'Įgaliotojas' },
            { key: 'representative', label: 'Įgaliotinis' },
          ],
        },
        {
          type: 'ntpi',
          label: 'NTPĮ',
          roles: [
            { key: 'principal', label: 'Įgaliotojas' },
            { key: 'representative', label: 'Įgaliotinis' },
          ],
        },
        {
          type: 'procuracy',
          label: 'Prokūra',
          roles: [
            { key: 'pro_principal', label: 'Prokūrą išdavęs asmuo' },
            { key: 'procurator', label: 'Prokuristas' },
          ],
        },
      ],
      manualFields: [
        { key: 'manual_admin', label: 'Naudotojų vadovas administratoriui' },
        { key: 'manual_registrator', label: 'Naudotojų vadovas registratoriui' },
        { key: 'manual_kac', label: 'Naudotojų vadovas KAC darbuotojui' },
        { key: 'manual_vasu', label: 'Naudotojų vadovas sutartiniam' },
        { key: 'manual_public_lt', label: 'Naudotojų vadovas Vieša paieška (LT)' },
        { key: 'manual_public_en', label: 'Naudotojų vadovas Vieša paieška (EN)' },
      ],
    }
  },
  created() {
    this.enumsClassifiers = Enums
    this.getData()
  },
  computed: {
    modeReadonly() {
      return false
    },
    smsDelayedSendEnabled() {
      return this.parseBooleanParam(this.formData.sms_delayed_send_enabled, true)
    },
    expiryReminderDaysHint() {
      return this.$t(
        'Galiojimo pabaigos priminimų dienos (atskirtos kableliu, pvz. 30,7). Palikite tuščią — priminimai nesiunčiami.'
      )
    },
  },
  methods: {
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },
    clearFile(event, name) {
      delete this.uploadedFiles[name]
      delete this.files[name]
      this.deletedFiles[name] = name
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        delete this.deletedFiles[name]
        this.uploadedFiles[name] = element
      }
    },
    parseBooleanParam(value, defaultValue = false) {
      if (value === true || value === 'true' || value === '1' || value === 1) {
        return true
      }
      if (value === false || value === 'false' || value === '0' || value === 0) {
        return false
      }
      return defaultValue
    },
    normalizeParameters(params) {
      const normalized = { ...params }
      const interval = Array.isArray(normalized.sms_delayed_send_interval)
        ? normalized.sms_delayed_send_interval
        : []
      normalized.sms_delayed_send_interval = [
        interval[0] || '',
        interval[1] || '',
      ]
      normalized.sms_delayed_send_enabled = this.parseBooleanParam(
        normalized.sms_delayed_send_enabled,
        true
      )
      const legacyExpiry =
        typeof normalized.expiry_reminder_days === 'string'
          ? normalized.expiry_reminder_days
          : null
      const expiryFromApi =
        normalized.expiry_reminder_days &&
        typeof normalized.expiry_reminder_days === 'object' &&
        !Array.isArray(normalized.expiry_reminder_days)
          ? normalized.expiry_reminder_days
          : {}

      const toExpiryField = (value) => {
        if (value === null || value === undefined) {
          return ''
        }
        return String(value)
      }

      normalized.expiry_reminder_days = {
        itpsi: toExpiryField(
          expiryFromApi.itpsi ??
            normalized.expiry_reminder_days_itpsi ??
            legacyExpiry
        ),
        ntpi: toExpiryField(
          expiryFromApi.ntpi ??
            normalized.expiry_reminder_days_ntpi ??
            legacyExpiry
        ),
        procuracy: toExpiryField(
          expiryFromApi.procuracy ??
            normalized.expiry_reminder_days_procuracy ??
            legacyExpiry
        ),
      }

      delete normalized.expiry_reminder_days_itpsi
      delete normalized.expiry_reminder_days_ntpi
      delete normalized.expiry_reminder_days_procuracy

      const rolesFromApi =
        normalized.expiry_reminder_roles &&
        typeof normalized.expiry_reminder_roles === 'object' &&
        !Array.isArray(normalized.expiry_reminder_roles)
          ? normalized.expiry_reminder_roles
          : {}

      normalized.expiry_reminder_roles = {}
      this.expiryReminderTypeConfigs.forEach(({ type, roles }) => {
        const allowed = roles.map((role) => role.key)
        const fromType = rolesFromApi[type]
        let selected = [...allowed]

        if (Array.isArray(fromType)) {
          selected = fromType.filter((key) => allowed.includes(key))
        } else if (fromType && typeof fromType === 'object') {
          selected = allowed.filter((key) => {
            const channels = fromType[key] || {}
            return this.parseBooleanParam(channels.email) || this.parseBooleanParam(channels.sms)
          })
        }

        normalized.expiry_reminder_roles[type] = selected
      })

      delete normalized.expiry_reminder_roles_itpsi
      delete normalized.expiry_reminder_roles_ntpi
      delete normalized.expiry_reminder_roles_procuracy

      return normalized
    },
    expiryReminderDaysRowLabel(reminderType) {
      return `${this.expiryReminderDaysHint} (${this.$t(reminderType.label)})`
    },
    expiryReminderRolesRowLabel(reminderType) {
      return `${this.$t('Priminimų gavėjai')} (${this.$t(reminderType.label)})`
    },
    expiryReminderRoleItems(reminderType) {
      return reminderType.roles.map((role) => ({
        text: this.$t(role.label),
        value: role.key,
      }))
    },
    onSmsDelayedSendEnabledChange() {
      if (!this.smsDelayedSendEnabled) {
        ;[
          'sms_delayed_send_interval.0',
          'sms_delayed_send_interval.1',
        ].forEach((field) => {
          this.errors.remove(field)
        })
      }
    },
    validateParameterFields() {
      let valid = true
      const expiryDaysRegex = /^(\d{1,3})(,\d{1,3})*$/
      const expiryDaysMessage = this.$t(
        'Priminimų dienos turi būti teigiami skaičiai, atskirti kableliu (pvz. 30,7)'
      )

      this.expiryReminderTypeConfigs.forEach(({ type }) => {
        const field = `expiry_reminder_days.${type}`
        this.errors.remove(field)
        const expiryDays = this.formData.expiry_reminder_days?.[type] || ''

        if (expiryDays !== '' && !expiryDaysRegex.test(expiryDays)) {
          this.errors.add({
            field,
            msg: expiryDaysMessage,
          })
          valid = false
        }
      })

      if (this.smsDelayedSendEnabled) {
        const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/
        const interval = this.formData.sms_delayed_send_interval || ['', '']
        if (!timeRegex.test(interval[0] || '')) {
          this.errors.add({
            field: 'sms_delayed_send_interval.0',
            msg: this.$t(
              'Intervalo pradžia turi būti formato HH:MM (pvz. 22:00)'
            ),
          })
          valid = false
        }
        if (!timeRegex.test(interval[1] || '')) {
          this.errors.add({
            field: 'sms_delayed_send_interval.1',
            msg: this.$t(
              'Intervalo pabaiga turi būti formato HH:MM (pvz. 08:00)'
            ),
          })
          valid = false
        }
      } else {
        ;[
          'sms_delayed_send_interval.0',
          'sms_delayed_send_interval.1',
        ].forEach((field) => {
          this.errors.remove(field)
        })
      }

      return valid
    },
    getData() {
      this.loadDefault = null
      this.pageloading = true
      this.loading = true

      this.$axios
        .post(`/system-parameters/list`)
        .then((res) => {
          this.formData = this.normalizeParameters(res.data.parameters)
        })
        .catch((err) => {
          window._VMA.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.clearErrors()
          this.loading = false
          this.pageloading = false
          this.loadDefault = false
        })
    },

    saveData() {
      if(this.getMaxUploadSize(20)){
        return this.$root.$emit('DATA_ERROR_DIRECT_TEXT', this.getMaxUploadSizeMsg(20))
      }
      if (!this.validateParameterFields()) {
        return this.$root.$emit('FORMAT_ERROR')
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()

          Object.keys(this.uploadedFiles).map((key) => {
            formData.append(key, this.uploadedFiles[key])
          })

          Object.keys(this.deletedFiles).map((key) => {
            formData.append('deleteFile[' + key + ']', this.deletedFiles[key])
          })

          formData.append('logout_time', this.formData.logout_time || '')
          formData.append('payment_time', this.formData.payment_time || '')
          formData.append('deregistration_time', this.formData.deregistration_time || '')
          formData.append('check_iltu', this.formData.check_iltu || '')
          formData.append('delete_mandates', this.formData.delete_mandates || '')
          formData.append('delete_statements', this.formData.delete_statements || '')
          formData.append('confirm_time', this.formData.confirm_time || '')
          formData.append('min_age', this.formData.min_age || '')
          formData.append('incapacity', this.formData.incapacity || false)
          formData.append('is_person_documents_mandatory', this.formData.is_person_documents_mandatory || false)
          formData.append('incapacity_object', this.formData.incapacity_object || false)
          formData.append('file_size', this.formData.file_size || false)
          formData.append('file_types', this.formData.file_types || false)
          formData.append('auto_signatures_procuracy', this.formData.auto_signatures_procuracy || false)
          formData.append('asmenys_insert_function', this.formData.asmenys_insert_function || null)
          formData.append('log_save_time', this.formData.log_save_time || '')
          formData.append(
            'sms_delayed_send_enabled',
            this.smsDelayedSendEnabled ? 'true' : 'false'
          )

          const smsInterval = this.formData.sms_delayed_send_interval || ['', '']
          formData.append(
            'sms_delayed_send_interval[0]',
            smsInterval[0] || ''
          )
          formData.append(
            'sms_delayed_send_interval[1]',
            smsInterval[1] || ''
          )
          formData.append(
            'expiry_reminder_time',
            this.formData.expiry_reminder_time || ''
          )
          this.expiryReminderTypeConfigs.forEach(({ type }) => {
            formData.append(
              `expiry_reminder_days[${type}]`,
              (this.formData.expiry_reminder_days?.[type] || '').trim()
            )
          })
          this.expiryReminderTypeConfigs.forEach(({ type }) => {
            ;(this.formData.expiry_reminder_roles?.[type] || []).forEach((roleKey) => {
              formData.append(`expiry_reminder_roles[${type}][]`, roleKey)
            })
          })

          let url = `system-parameters`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK', res.data.message)
              this.getData()
              this.deletedFiles = {};
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },

    clearErrors() {
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/color.scss';

.param-expiry-reminders {
  &__time-row {
    margin-bottom: 0;

    ::v-deep .v-col {
      padding-bottom: 0;
    }

    ::v-deep .param-row__label,
    ::v-deep .param-row__value {
      padding-bottom: 0.25rem !important;
    }
  }

  &__fields-row {
    margin-top: 0;

    ::v-deep .v-col {
      padding-top: 0;
    }

    ::v-deep tbody tr:first-child .param-row__label,
    ::v-deep tbody tr:first-child .param-row__value {
      padding-top: 0.25rem !important;
    }
  }
}

.param-section-header {
  width: 100%;

  &--spaced {
    margin-top: 1.5rem;
  }

  .param-section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    padding-bottom: 0.5rem;
    margin-bottom: 0;
  }

  .v-divider {
    margin-bottom: 1rem;
  }
}

::v-deep .param-fields-table {
  table-layout: fixed;
  width: 100%;
  background-color: $thBackground !important;

  .param-fields-table__label-col {
    width: 60%;
  }

  .param-fields-table__value-col {
    width: 40%;
  }

  td,
  th {
    border-bottom: none !important;
    background-color: $thBackground !important;
  }

  tbody tr,
  tbody tr > td,
  tbody tr:hover,
  tbody tr:hover > td {
    background-color: $thBackground !important;
  }

  .param-row {
    .param-row__label,
    .param-row__value {
      vertical-align: middle !important;
    }

    .param-row__label-inner,
    .param-row__control {
      display: flex;
      align-items: center;
      min-height: 40px;
    }

    .param-row__control .v-input {
      margin-top: 0 !important;
      padding-top: 0 !important;
    }

    .param-row__control .v-input__details {
      display: none !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  .param-row__control {
    max-width: 14rem;

    .v-input,
    .v-input__control,
    .v-input__slot,
    .v-text-field {
      max-width: 14rem;
    }

    .v-autocomplete {
      max-width: min(100%, 22rem);
    }
  }

  &.param-fields-table--manuals .param-row--file {
    .param-row__label-inner {
      min-height: 80px;
    }

    .param-row__control--file {
      display: block !important;
      max-width: 100% !important;
      min-height: auto !important;

      .v-input,
      .v-input__control,
      .v-input__slot,
      .v-text-field,
      .v-file-input {
        width: 100%;
        max-width: 100% !important;
      }

      .v-input__control {
        min-height: unset !important;
      }

      .v-file-input.file-input-active .v-input__control > .v-input__slot {
        min-height: 80px !important;
      }

      .file-drop {
        width: 100% !important;
        max-height: 80px !important;
      }
    }
  }
}
</style>
